import { TableDataQa } from 'commons/types/enums'
import { Table } from 'ui/components/Table'
import { useChangeTemplateStatus } from '~bank-document-templates/hooks'
import { useTemplatesListContext } from '~bank-document-templates/list/context'

import { columns } from './columns'

export const TemplatesTable = () => {
  const { routeApi, data, isLoading } = useTemplatesListContext()
  const navigate = routeApi.useNavigate()
  const {
    items,
    form: { page, size, sortDesc },
    total
  } = data

  const { openStatusChangeConfirmation } = useChangeTemplateStatus()

  return (
    <Table
      dataQa={TableDataQa.DOCUMENT_TEMPLATES_LIST}
      columns={columns({ navigate, onStatusChange: openStatusChangeConfirmation })}
      dataSource={items.map((item) => ({ item }))}
      pagination={{
        page,
        size,
        onChange: (page: number, size: number) => {
          navigate({ to: '.', search: (prev) => ({ ...prev, page, size }) })
        },
        total
      }}
      sorting={{
        order: [{ field: 'name', direction: sortDesc ? 'DESC' : 'ASC' }],
        onChange: ({ direction }) => {
          navigate({ to: '.', search: (prev) => ({ ...prev, sortDesc: direction === 'DESC' }) })
        }
      }}
      loading={isLoading}
    />
  )
}
